import React, { useEffect, useState } from 'react';
import ReactPlayer from 'react-player';
import { Box } from '@mui/material';
import { useStyles } from './styles';
import { Modal } from 'src/components/shared';
import images from "../../../../config/images";

function StepMedia({ step, onAction, playVideo, setPlayVideo }) {
  const [showVideoPlayer, setShowVideoPlayer] = useState(false);

  useEffect(() => {
    setShowVideoPlayer(playVideo);
  }, [playVideo]);

  const toggleVideoPlayer = () => {
    if (step?.isVideo) {
      setPlayVideo(!setPlayVideo)
     setShowVideoPlayer(!showVideoPlayer);
    }
  };

  const classes = useStyles();
  const media = step.thumbnail;
  const video = step.video_url ;

    function findValueByKey(obj, key) {
        return obj[key];
    }

  return (
    <>
      <Box>
        <img
          onClick={toggleVideoPlayer}
          src={findValueByKey(images.onboarding ,media)}
          style={{ mixBlendMode: 'multiply' }}
          className={classes.stepMediaThumbnail}
          alt="Demo"
        />
      </Box>
      <Modal size="lg" padding={false} open={showVideoPlayer} onClose={toggleVideoPlayer}>
        <div>
          <ReactPlayer
            playing={showVideoPlayer}
            controls={true}
            width="100%"
            height="100%"
            url={video}
            onEnded={() => {
              onAction();
              toggleVideoPlayer();
            }}
          />
        </div>
      </Modal>
      {/* <Modal
        className={classes.videoModal}
        show={showVideoPlayer}
        onHide={toggleVideoPlayer}
      >
        <div>
          <ReactPlayer
            playing={showVideoPlayer}
            controls={true}
            width="100%"
            height="100%"
            url={video}
            onEnded={() => {
              onAction();
              toggleVideoPlayer();
            }}
          />
        </div>
      </Modal> */}
    </>
  );
}

export default StepMedia;
